import Vue from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery'
import store from './vuex/store' // 引入store
import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@/assets/css/font-awesome.min.css'
import '@/assets/jquery-confirm/jquery-confirm.css'
import '@/assets/jquery-confirm/jquery-confirm.js'
import '@/assets/js/jquery.validate.js'

import VTcPlayer from 'v-tcplayer'
Vue.use(VTcPlayer, { name: 'V-TcPlayer' })

//import AOS from 'aos'
//import 'aos/dist/aos.css'

/*AOS.init({
	easing: 'ease-out-back',
	duration: 1000
})*/

Vue.config.productionTip = false

// 添加请求拦截器
axios.interceptors.request.use(function(config) {
	config.headers['X-Requested-With'] = 'XMLHttpRequest'
	return config;
}, function(error) {
	return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
	return response;
}, function(error) {
	return Promise.reject(error);
});

new Vue({
	store,
	router,
	render: h => h(App)
}).$mount("#app")